<script lang="ts" setup></script>

<template>
  <svg
    fill="none"
    height="48"
    viewBox="0 0 48 48"
    title="Dynamic Solar Shading"
    width="48"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.23047 37.6094C4.56658 38.0967 4.92136 38.5729 5.29294 39.0341H42.7055C43.0771 38.5729 43.43 38.0986 43.768 37.6094H4.23047Z"
      fill="url(#paint0_radial_2035_3005)" />
    <path
      d="M0.527344 29.0156C0.630044 29.4955 0.745814 29.9698 0.876523 30.4404H47.125C47.2557 29.9717 47.3715 29.4974 47.4742 29.0156H0.527344Z"
      fill="url(#paint1_radial_2035_3005)" />
    <path
      d="M36.0429 44.7646C36.7935 44.3295 37.5161 43.8533 38.2126 43.3398H9.78906C10.4856 43.8515 11.2082 44.3276 11.9588 44.7646H36.0429Z"
      fill="url(#paint2_radial_2035_3005)" />
    <path
      d="M2.53516 34.7461C2.7779 35.2297 3.03745 35.7059 3.31194 36.1708H44.6887C44.9632 35.7059 45.2209 35.2316 45.4655 34.7461H2.53516Z"
      fill="url(#paint3_radial_2035_3005)" />
    <path
      d="M33.1221 1.79631C30.31 0.640473 27.2309 0 24.0005 0C20.7701 0 17.691 0.638606 14.8789 1.79631H33.1203H33.1221Z"
      fill="url(#paint4_radial_2035_3005)" />
    <path
      d="M6.55078 7.52629H41.4519C40.9851 7.03146 40.4958 6.55718 39.9879 6.10156H8.01472C7.50682 6.55531 7.0176 7.0296 6.55078 7.52629Z"
      fill="url(#paint5_radial_2035_3005)" />
    <path
      d="M6.55078 40.4766C7.0176 40.9714 7.50682 41.4457 8.01472 41.9013H39.9879C40.4958 41.4475 40.9851 40.9733 41.4519 40.4766H6.55078Z"
      fill="url(#paint6_radial_2035_3005)" />
    <path
      d="M0 24.0005C0 24.2395 0.00373454 24.4766 0.0112036 24.7119H47.9888C47.9963 24.4748 48 24.2376 48 24.0005C48 23.7633 47.9963 23.5243 47.9888 23.2891H0.0112036C0.00373454 23.5262 0 23.7633 0 24.0005Z"
      fill="url(#paint7_radial_2035_3005)" />
    <path
      d="M1.32422 31.8828C1.49227 32.3646 1.6734 32.8389 1.86946 33.3075H46.1274C46.3235 32.8407 46.5046 32.3646 46.6727 31.8828H1.32422Z"
      fill="url(#paint8_radial_2035_3005)" />
    <path
      d="M3.31194 11.8281C3.03745 12.2931 2.77977 12.7674 2.53516 13.2529H45.4637C45.2209 12.7692 44.9614 12.2931 44.6869 11.8281H3.31194Z"
      fill="url(#paint9_radial_2035_3005)" />
    <path
      d="M0.0976562 26.1523C0.140603 26.6304 0.196621 27.1065 0.26571 27.5771H47.7354C47.8064 27.1065 47.8605 26.6322 47.9035 26.1523H0.0976562Z"
      fill="url(#paint10_radial_2035_3005)" />
    <path
      d="M5.29294 8.96484C4.92136 9.42606 4.56844 9.90035 4.23047 10.3896H43.7661C43.43 9.90221 43.0753 9.42606 42.7037 8.96484H5.29294Z"
      fill="url(#paint11_radial_2035_3005)" />
    <path
      d="M14.8789 46.2031C17.691 47.359 20.7701 47.9994 24.0005 47.9994C27.2309 47.9994 30.31 47.3608 33.1221 46.2031H14.8808H14.8789Z"
      fill="url(#paint12_radial_2035_3005)" />
    <path
      d="M11.9588 3.23438C11.2082 3.66945 10.4856 4.1456 9.78906 4.6591H38.2126C37.5161 4.14747 36.7935 3.67132 36.0429 3.23438H11.9588Z"
      fill="url(#paint13_radial_2035_3005)" />
    <path
      d="M0.26571 20.4258C0.194754 20.8963 0.140603 21.3706 0.0976562 21.8505H47.9035C47.8605 21.3725 47.8045 20.8963 47.7354 20.4258H0.26571Z"
      fill="url(#paint14_radial_2035_3005)" />
    <path
      d="M0.876523 17.5586C0.745814 18.0273 0.630044 18.5016 0.527344 18.9833H47.4742C47.3715 18.5034 47.2557 18.0291 47.125 17.5586H0.876523Z"
      fill="url(#paint15_radial_2035_3005)" />
    <path
      d="M1.86946 14.6953C1.6734 15.1621 1.49227 15.6383 1.32422 16.12H46.6727C46.5046 15.6383 46.3235 15.164 46.1274 14.6953H1.86946Z"
      fill="url(#paint16_radial_2035_3005)" />
    <defs>
      <radialGradient
        id="paint0_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(8.04343 38.7447) scale(35.1887 35.1887)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(5.0536 30.1509) scale(41.7839 41.7839)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(12.5302 44.4751) scale(25.2996 25.2996)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(6.67489 35.8814) scale(38.2062 38.2062)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(16.6379 1.43219) scale(16.2396)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(9.9156 7.23686) scale(31.0639 31.0639)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(9.9156 41.6119) scale(31.0639 31.0639)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(4.62896 24.4244) scale(42.7212 42.7212)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(5.69736 33.0181) scale(40.361 40.361)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(6.67489 12.9634) scale(38.2062 38.2062)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(4.70794 27.2876) scale(42.5476 42.5476)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(8.04343 10.1001) scale(35.1887)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(16.6379 47.6353) scale(16.2396 16.2396)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(12.5302 4.36967) scale(25.2996 25.2996)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint14_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(4.70794 21.5592) scale(42.5476 42.5476)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint15_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(5.0536 18.692) scale(41.7839 41.7838)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_2035_3005"
        cx="0"
        cy="0"
        gradientTransform="translate(5.69736 15.8287) scale(40.361 40.361)"
        gradientUnits="userSpaceOnUse"
        r="1">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped></style>
